const getServerLocation = () => {
  const serverLocation = process.env.REACT_APP_API_URL
  return serverLocation;
};

const getMediaLocation = () => {
  const mediaLocation = process.env.REACT_APP_MEDIA_URL
  return mediaLocation;
};

const getWebsocketServerLocation = () => {
  const serverLocation = process.env.REACT_APP_WS_URL
  return serverLocation;
};

export const dataLoaderSettings = {
  apiURL: getServerLocation(),
  mediaURL: getMediaLocation(),
  websocketURL: getWebsocketServerLocation(),
};

// Fecha más antigua con datos Waze disponibles (YYYY-MM-DD). Los date pickers
// no permiten seleccionar fechas anteriores a esta — no hay datos antes.
export const DATA_START_DATE = "2026-03-11";